/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TestABGearIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Test AB Gear',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m4.847 17.782-1.309 3.986a.236.236 0 0 1-.262.193H.9c-.143 0-.19-.072-.167-.242l4.9-14.156a3.743 3.743 0 0 0 .214-1.3c0-.1.048-.169.143-.169H9.3c.119 0 .143.024.167.145l5.5 15.509c.024.145 0 .217-.143.217H12.15a.238.238 0 0 1-.238-.145l-1.38-4.034Zm4.925-2.633c-.5-1.594-1.618-4.952-2.094-6.643h-.024c-.381 1.619-1.332 4.445-2.046 6.643ZM16.668 18.489c.009 0 .23-.314.387-.468l1-1a3.028 3.028 0 0 1 1.262-.747l2.924-11.1c.024-.1 0-.121-.095-.121h-2c-.1 0-.119 0-.144.1-.002-.005-3.484 13.366-3.334 13.336ZM25.368 14.015h1.322a3.042 3.042 0 0 1 2.173.917h.161a6.171 6.171 0 0 1 1.618.169 2.111 2.111 0 0 1 1.445 1.05 3.033 3.033 0 0 1 1.913.866l1.008 1.008c.066.066.091.153.149.224a4.482 4.482 0 0 0 .149-1.118 4.05 4.05 0 0 0-2.284-3.745 3.789 3.789 0 0 0 1.5-3.14c0-1.546-.762-4.2-5.734-4.2-1.594 0-3.759.048-4.615.072-.119.024-.143.1-.143.218v8.006a3.024 3.024 0 0 1 1.338-.327Zm1.491-5.461c.5 0 1.118-.024 1.88-.024 1.95 0 3 .7 3 2.126a2.3 2.3 0 0 1-.9 1.908 14.426 14.426 0 0 0-2.165-.145h-1.815ZM34.952 24.678h-2.315a6.69 6.69 0 0 0-.977-2.373l1.648-1.648a.661.661 0 0 0 0-.935l-1-1a.661.661 0 0 0-.935 0l-1.648 1.648a6.693 6.693 0 0 0-2.373-.978v-2.316a.661.661 0 0 0-.661-.661h-1.324a.661.661 0 0 0-.661.661v2.315a6.692 6.692 0 0 0-2.373.978l-1.648-1.649a.661.661 0 0 0-.935 0l-1 1a.661.661 0 0 0 0 .935l1.65 1.65a6.69 6.69 0 0 0-.977 2.373H17.1a.661.661 0 0 0-.661.661v1.322a.661.661 0 0 0 .661.661h2.315A6.69 6.69 0 0 0 20.4 29.7l-1.648 1.648a.661.661 0 0 0 0 .935l1 1a.661.661 0 0 0 .935 0l1.648-1.648a6.692 6.692 0 0 0 2.373.977v2.315a.661.661 0 0 0 .661.661h1.322a.661.661 0 0 0 .661-.661V32.61a6.693 6.693 0 0 0 2.373-.977l1.648 1.648a.661.661 0 0 0 .935 0l1-1a.661.661 0 0 0 0-.935L31.66 29.7a6.69 6.69 0 0 0 .977-2.373h2.315a.661.661 0 0 0 .661-.661v-1.327a.661.661 0 0 0-.661-.661ZM26.028 29.6a3.6 3.6 0 1 1 3.6-3.6 3.6 3.6 0 0 1-3.6 3.6Z"
    />
  </svg>`;
};
